import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ModalController, NavController } from "@ionic/angular";
import { AppService } from "src/app/_services/app.service";
import { LocalStorageService } from "src/app/_services/localStorage.service";
import { ProviderService } from "src/app/_services/provider.service";
import { PusherService } from "src/app/_services/pusher.service";
import { ConfirmationModalComponent } from "../confirmation-modal/confirmation-modal.component";

@Component({
  selector: "app-meeting-conformation-modal",
  templateUrl: "./meeting-conformation-modal.component.html",
  styleUrls: ["./meeting-conformation-modal.component.scss"],
  standalone: false,
})
export class meetingConformationModalComponent implements OnInit {
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  @Input() status!: string;
  @Input() id?: number;
  buttonText: string = "RDV_PAGE.REFUSED_CONTINUE_BUTTON";
  messageText: string = "RDV_PAGE.SUCCESS_MODAL_MESSAGE_REFUSED";
  role: any;
  isLoading: boolean = false;
  constructor(
    private localStorageServices: LocalStorageService,
    private navController: NavController,
    private providerService: ProviderService,
    private laravelEchoService: PusherService,
    private modalCtrl: ModalController,
    private appService: AppService
  ) {
    this.role = this.localStorageServices.getUserRole();
  }

  ngOnInit() {
    this.handleText();
  }
  handleCancelModal(value: boolean, id: number = 0) {
    this.appService.dispatchModal("CANCEL_DEMAND_MODAL", {
      open: value,
      id: id,
      type: "provider",
    });
  }
  handleText() {
    switch (this.status) {
      case "PENDING":
        this.buttonText = "RDV_PAGE.CONTINUE";
        this.messageText = "RDV_PAGE.SUCCESS_MODAL_MESSAGE_PENDING";
        break;
      case "ACCEPTED":
        this.buttonText = "RDV_PAGE.CONTINUE";
        this.messageText = "RDV_PAGE.SUCCESS_MODAL_MESSAGE_ACCEPTED";
        break;
      case "REFUSED":
        this.messageText = "RDV_PAGE.SUCCESS_MODAL_MESSAGE_REFUSED";
        this.buttonText = "RDV_PAGE.REFUSED_CONTINUE_BUTTON";
        break;
      default:
        break;
    }
  }

  handleValidBtnClick() {
    switch (this.status) {
      case "PENDING":
        this.close.emit();
        setTimeout(() => {
          this.goTo("");
        }, 200);
        break;
      case "ACCEPTED":
        this.closeModal();
        setTimeout(() => {
          this.goTo("");
        }, 200);
        break;
      case "REFUSED":
        let id = this.id;
        this.closeModal();
        setTimeout(() => {
          id && this.goTo(`/rendez-vous/${id}`);
        }, 200);
        break;
      default:
        this.close.emit();
        setTimeout(() => {
          this.goTo("");
        }, 200);
        break;
    }
  }
  closeModal() {
    this.laravelEchoService.resetMeetingResponse();
  }

  async cancleDemand() {
    this.isLoading = true;
    const res = await this.openModal();
    if (res.role === "confirm") {
      this.providerService
        .cancelDemande({
          demande_id: this.id,
          type: "RDV",
        })
        .subscribe((res: any) => {
          this.isLoading = false;

          this.closeModal();
          this.localStorageServices.dropCurrentDemand();
          setTimeout(() => {
            this.goTo("");
          }, 200);
        });
    }
  }

  goTo(path: string) {
    let baseUrl = "";
    switch (this.role) {
      case "client":
        baseUrl = "particulier";
        break;
      case "prestataire":
        baseUrl = "prestataire";
        break;
    }
    this.navController.navigateForward(["/" + baseUrl + "/" + path]);
  }
  async openModal() {
    const modal = await this.modalCtrl.create({
      component: ConfirmationModalComponent,
      initialBreakpoint: 0.5,
    });
    modal.present();
    const { data, role } = await modal.onWillDismiss();
    return { data, role };
  }
}
